import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Trigger Cron Client Month Use Case
 * Calls the CFO cron_client_month API to generate monthly report and persist mapped values.
 * Typically invoked after a successful month close to sync client monthly data.
 */
export class TriggerCronClientMonthUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(year: number, month: number): Promise<void> {
    return await this.repository.triggerCronClientMonth(year, month);
  }
}
